import { render, staticRenderFns } from "./validationPta.vue?vue&type=template&id=0d973181"
import script from "./validationPta.vue?vue&type=script&lang=js"
export * from "./validationPta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports